var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 216,
    viewBox: "0 0 212 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    transform: "translate(6 0.477539)",
    fill: "#E5F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8067 107.366C52.993 131.873 76.2626 159.564 104.81 159.564C132.79 159.564 154.008 132.613 155.847 107.194C160.75 105.499 163.803 101.026 163.803 95.0474V77.8431C163.803 73.9033 163.803 66.9958 154.171 65.3184V52.0367C154.171 28.4668 140.495 15.4775 115.646 15.4775C100.072 15.4775 84.8153 20.5614 80.9435 21.9464C62.8075 22.4109 48.2254 35.7356 48.2254 52.0367V66.6173C44.4114 68.5872 38.594 72.4668 38.594 77.8431V95.0474C38.594 101 44.3825 105.749 50.8067 107.366Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.005 163.959L108.562 193.316C107.772 193.757 106.896 193.972 106 193.972C105.085 193.972 104.17 193.742 103.38 193.275L52.7766 163.882C22.216 163.987 0.0540771 182.022 0.0540771 206.875V211.176C0.0540771 213.551 2.21152 215.478 4.8698 215.478H207.13C209.779 215.478 211.946 213.551 211.946 211.176V206.875C211.956 181.914 191.046 164.432 161.005 163.959Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3466 156.63L66.5807 161.645L106.06 184.561L146.404 161.98L140.801 154.677C130.919 162.89 118.6 168.148 104.808 168.148C91.9596 168.165 80.1996 163.684 70.3466 156.63Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.599d35e6bfce51dca8a2ae4c10f0866a.svg";
export { ForwardRef as ReactComponent };